import React from 'react'
import Banner22 from '../../Common/Banner2'
import img1111 from "../../../Assets/Images/member_0003.png"
// import img1111 from "../../../Assets/Images/memberimg.png"
import Membermain from '../member_tw/membermain'
import Mreason from "../member_tw/mreason"
import Member_Map from '../member_tw/memberMap'
import MemberNotice from '../member_tw/memberNotice'
import MemberNotice2 from '../member_tw/memberNotice2'
// import FREEVersion from './FREEVersion'
//import img1 from "../../../../Assets/Images/freeimg.png";

import MemberMap from './memberMap'
import { useNavigate } from "react-router-dom";
import { RoutesString } from "../../Modules/routesString";
import * as Scroll from "react-scroll"
function Member() {
  const scroll = Scroll.animateScroll
  return (
    <main>

       
        <Banner22
        img1111={img1111}
        title={`專屬我的私人諮詢箱 CSbye`}
        subTitle="如果想一次性確認我的諮詢情況和之前的明細的話怎麼辦？"
        detail={``}

       textButton={"登錄普通會員"}
        onPressButton={() => {{alert('準備中')}}}
          // scroll.scrollToTop()
          // navigation(RoutesString.Customer);       
        textButton2={"交換積分 (準備中)"}
        // textButton={"서비스 문의하기"}
        backgroundColor="#63aeff"
      />
      
      
      <Member_Map/>
      <Mreason/>
      <Membermain/>
      <MemberNotice/>
      <MemberNotice2/>
      
      
      {/* <FREEplatform/> */}
      {/* <Policy /> */}
    </main>
  )
}




//function Free() {
  //return (
    //<main>
      //  <Banner
        //img={img}
 //       title={`CSbye 플랫폼 평생무료!`}
   //     subTitle="문의량이 적은 소규모, 스타트업 기업이라면?"
     //   detail={``}
       // onPressButton={() => {alert('준비중입니다.')}}
     //   textButton={"CSbye플랫폼 시작하기"}
   //     backgroundColor="#c1e0ff"
    //  />
     // <FREEmain />
 //   </main>
//  )
//}


//const Free = () => {
  //return (
    //<div id="star" className="bg-f2f3f8">
      //무료이용중
     
    //</div>

  //);
  

//};

export default Member;
